import BaseModelAPI from '../BaseModelAPI';

export default class JobPosition extends BaseModelAPI {
	static entity = 'jobposition';
	static entityName = 'jobposition';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.userInfoId = '';
			this.userInfo = {};
			this.approvalStructureId = '';
			this.approvalStructure = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}